import { ReactNode, useRef, useState } from "react";
import ChevronDown from "@assets/icon/chevron-down.svg?react";
import { cn } from "@utils/tailwind-merge";


interface CollapseTransparentProps  {
  title: ReactNode;
  children: ReactNode;
  className?: string;
  isShow?: boolean;
}


export function CollapseTransparent(props: CollapseTransparentProps){

  const [isCollapseShow, setIsCollapseShow] = useState(Boolean(props.isShow));
  const contentRef = useRef<HTMLDivElement | null>(null);

  return (
    <div 
      className={cn(
        " rounded-lg p-2 container w-full",
        "flex flex-col transition-transform", 
        props.className
      )}
    >
      <button className="font-semibold flex justify-between w-full" onClick={() => setIsCollapseShow(!isCollapseShow)}>
        {props.title}
        <ChevronDown className={cn("w-5 ", {"rotate-180": isCollapseShow})} />
      </button>
      <div 
        ref={contentRef}
        style={
          isCollapseShow
          ? { maxHeight: contentRef.current?.scrollHeight }
          : { maxHeight: 0 }
        }

        className={cn(" transition-all overflow-hidden ")}
      >
        {props.children}
      </div>
    </div>
  )
}